import { AbstractControl, ValidationErrors } from '@angular/forms';
import dayjs from 'dayjs';
import { AbstractRule } from './abstract-rule';
import { ValidationResultFactory } from './validation-result-factory';

export class DatePastRule extends AbstractRule {
  validate(control: AbstractControl): ValidationErrors | null {
    const resultFactory = new ValidationResultFactory(
      'DatePastRule',
      this.validationService
    );

    if (control.value) {
      if (!dayjs(control.value).isBefore(dayjs())) {
        resultFactory.addResult('DatePast');
      }
    }

    return resultFactory.validationErrors;
  }
}
